import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router';

Vue.use(Router)
Router.prototype.replace = function push (location) {
	return originalPush.call(this, location).catch(err => err)
}
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
const constantRouterMap = [{
	path: '/',
	name: '',
	redirect: 'login',
},
{
	path: '/login',
	name: '登录',
	component: () => import('../views/Login.vue'),
},
{
	path: '/avoidLogin',
	name: '登录2',
	component: () => import('../views/avoidLogin.vue'),
},
{
	path: '/layout',
	name: '首页',
	component: () => import('../views/Layout.vue'),
},

{
	path: '/facility/:id',
	name: '设施BIM',
	component: () => import('../views/FacilityBim/FacilityBim.vue'),
},
{
	path: '/home',
	name: '后台',
	component: () => import('../views/houTai/index.vue'),
	redirect: '/home/qiaoliangliebiao',
	children: [
		// 桥梁管理
		{
			path: 'qiaoliangliebiao',
			name: '桥梁列表',
			component: () => import('../views/houTai/qiaoLiangGuanLi/qiaoLiangLieBiao.vue')
		},
		{
			path: 'qiaoliangtaizhang',
			name: '桥梁台账',
			component: () => import('../views/houTai/qiaoLiangGuanLi/qiaoLiangTaiZhang.vue')
		},
		{
			path: 'anjuanxinxi',
			name: '案卷信息',
			component: () => import('../views/houTai/qiaoLiangGuanLi/anJuanXinXi.vue')
		},
		// 数据管理
		{
			path: 'shiceshuju',
			name: '实测数据',
			component: () => import('../views/houTai/shuJuGuanLi/shiCeShuJu.vue')
		}, {
			path: 'yujingzhishezhi',
			name: '预警值设置',
			component: () => import('../views/houTai/shuJuGuanLi/yujingzhishezhi.vue')
		}, {
			path: 'yujingbaojingqingkuang',
			name: '预警报警情况',
			component: () => import('../views/houTai/shuJuGuanLi/yujingbaojingqingkuang.vue')
		}, {
			path: 'jiancebaogao',
			name: '检测报告',
			component: () => import('../views/houTai/shuJuGuanLi/jiancebaogao.vue')
		},
		// 巡查管理
		{
			path: 'yanghudanwei',
			name: '养护单位列表',
			component: () => import('../views/houTai/xunChaGuanLi/yanghudanwei.vue')
		},
		{
			path: 'xunchajihua',
			name: '巡查计划',
			component: () => import('../views/houTai/xunChaGuanLi/xunchajihua.vue')
		},
		{
			path: 'xunchajihua1',
			name: '巡查计划',
			component: () => import('../views/houTai/xunChaGuanLi/xunchajihua1.vue')
		},
		{
			path: 'xunjianjilu',
			name: '巡检记录',
			component: () => import('../views/houTai/xunChaGuanLi/xunjianjilu.vue')
		},
		// 设备管理
		{
			path: 'shebeileixing',
			name: '设备类型',
			component: () => import('../views/houTai/sheBeiGuanLi/shebeileixing.vue')
		},
		{
			path: 'shebeiliebiao',
			name: '设备列表',
			component: () => import('../views/houTai/sheBeiGuanLi/shebeiliebiao.vue')
		},
		{
			path: 'daoqitixing',
			name: '到期提醒',
			component: () => import('../views/houTai/sheBeiGuanLi/daoqitixing.vue')
		}, {
			path: 'weixiujilu',
			name: '维修记录',
			component: () => import('../views/houTai/sheBeiGuanLi/weixiujilu.vue')
		},
		// 系统管理
		{
			path: 'yonghu',
			name: '用户管理',
			component: () => import('../views/houTai/xiTongGuanLi/yonghu.vue')
		},
		{
			path: 'juese',
			name: '角色管理',
			component: () => import('../views/houTai/xiTongGuanLi/juese.vue')
		}, {
			path: 'quyu',
			name: '区域管理',
			component: () => import('../views/houTai/xiTongGuanLi/quyu.vue')
		}, {
			path: 'caidan',
			name: '菜单管理',
			component: () => import('../views/houTai/xiTongGuanLi/caidan.vue')
		}, {
			path: 'usercenter',
			name: '个人中心',
			component: () => import('../views/houTai/xiTongGuanLi/usercenter.vue')
		}, {
			path: 'approval',
			name: '账号审批',
			component: () => import('../views/houTai/xiTongGuanLi/shenpi.vue')
		},

		// 暂时不用
		{
			path: 'jiance',
			name: '检测系统',
			component: () => import('../views/houTai/jianCeXiTong/index.vue')
		},
		{
			path: 'video',
			name: '视频管理',
			component: () => import('../views/houTai/shiPinGuanLi/index.vue')
		},
	]
},
]
export default new Router({
	mode: 'hash',
	// base: process.env.BASE_URL,
	routes: constantRouterMap
})
